import React, { useState, useRef, useCallback } from "react";
import { useSelector, shallowEqual, useDispatch } from "react-redux";

import { putUpdateAnnotation, removeAnnotation, createAnnotation } from "../../../redux/reducers/animalResearchSlice";
import message, {MessageContainer} from "../../../qg-components/src/libs/Message/index";

export const useAnnotoriou = ( props ) => {
  const usedispatch = useDispatch();

  // 标注痕迹
  const [annoHistory, setAnnoHistory] = useState([]);
  // 标注实例 annotorious-openseadragon
  const [annotorious, setAnnotorious] = useState(null);
  const annoRef = useRef(annoHistory);

  const createAnnoInfo = useCallback((params, anno, annos) => {
    usedispatch(createAnnotation(params, (info) => {
      setAnnoHistory([...annoRef.current, {...anno, annoID: info.ID, slideID: info.SlideID}]);
    }))
  }, [annoHistory])

  // 创建标注 由监听createAnnotation调用而来
  const addAnnotations = (anno, viewerState, studyInfo) => {
    let params = {
      Content: JSON.stringify(anno),
      SlideID: viewerState.slideId
    };
    console.log(studyInfo,annoHistory, '---', )
    createAnnoInfo(params, anno, studyInfo.Annotation);
  };

  // 还原标注
  const reductionAnno = (annoArg) => {
    if(annoArg && annoArg.length) {
      let annoList = annoArg.map((item,index) => {
        let content = JSON.parse(item.Content);
        return{ ...content, annoID: item.ID, slideID: item.SlideID}
      });
      return annoList;
    };
    return []
  };

  // 更新标注信息
  const updateAnnoInfo = ( annoInfo ) => {
    let { slideID, annoID, ...content} = annoInfo
    let params = {
      Content: JSON.stringify(content),
      SlideID: slideID, 
      ID: annoID,
    }
    usedispatch(putUpdateAnnotation(params, (info) => {
      reductionAnno(info.Content);
    }))
  };

  // 删除标注
  const removeAnno = (anno) => {
    let params = {id: anno.annoID};
    usedispatch(removeAnnotation(params, (info) => {
      message.success("删除成功");
    }))
  }
  
  return { annoHistory, annotorious, setAnnoHistory, setAnnotorious, annoRef, reductionAnno, removeAnno, updateAnnoInfo, addAnnotations }
}